export type LeaveType = 'vacation' | 'sick' | 'unpaid' | 'other';
export type LeaveStatus = 'requested' | 'approved' | 'rejected' | 'cancelled';

export const LEAVE_TYPES: { value: LeaveType; label: string }[] = [
  { value: 'vacation', label: 'Vacation' },
  { value: 'sick', label: 'Sick' },
  { value: 'unpaid', label: 'Unpaid' },
  { value: 'other', label: 'Other' },
];

export const LEAVE_STATUSES: { value: LeaveStatus; label: string }[] = [
  { value: 'requested', label: 'Requested' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const LEAVE_TYPE_LABEL: Record<LeaveType, string> = Object.fromEntries(
  LEAVE_TYPES.map((t) => [t.value, t.label]),
) as Record<LeaveType, string>;

export const LEAVE_STATUS_LABEL: Record<LeaveStatus, string> = Object.fromEntries(
  LEAVE_STATUSES.map((s) => [s.value, s.label]),
) as Record<LeaveStatus, string>;
